/** Acima disso, colar o SQL num textarea trava o browser (org.insert). */
export const SQL_INLINE_MAX_BYTES = 512 * 1024;

export function shouldInlineSqlFile(byteLength: number): boolean {
  return byteLength <= SQL_INLINE_MAX_BYTES;
}
